import { Component } from '@angular/core';

//noinspection TypeScriptCheckImport
import { NguiDatetime } from '@ngui/datetime-picker';
NguiDatetime.firstDayOfWeek = 0; //e.g. 1, or 6

@Component({
  selector: 'my-app',
  template: `
    <a href="" routerLink="/directive-test">Directive</a>
    <a href="" routerLink="/component-test">Component</a>
    <router-outlet></router-outlet>`
})
export class AppComponent {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/strip-loader/lib?strip[]=debug,strip[]=console.log!./app/app.component.ts